export default __webpack_public_path__ + "static/media/Ellarock.5e5e8326.jfif";